@if (titlePresent && (descriptionPresent || otherPresent)) {
    <p style="padding-bottom: 10px !important;">
        <span style="font-weight: bold" [innerHTML]="title"></span>&nbsp;
        @if (descriptionPresent) {
            <span [innerHTML]="description"><br /><br/></span>
        }
        @if (otherPresent) {
            <span [innerHTML]="other"></span>
        }
    </p>
}
@if (titlePresent && !descriptionPresent && !otherPresent) {
    <span style="padding-bottom: 10px !important;">
        <span style="font-weight: bold" [innerHTML]="title"></span>
    </span>
}
@if (!titlePresent && descriptionPresent) {
    <p [innerHTML]="description" style="padding-bottom: 10px !important;"><br /><br/></p>
}
@if (!titlePresent && otherPresent) {
    <span [innerHTML]="other"></span>
}
